// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__U3Xdv","ranges":"BmiRanges_ranges__2C5Wt"};